import React from 'react';
import { EyeIcon, RouteIcon, WrenchIcon, ZapIcon } from 'lucide-react';
import { SectionHeader } from './ui/SectionHeader';
import { benefits } from '../data/content';
const ICONS = {
  route: RouteIcon,
  wrench: WrenchIcon,
  eye: EyeIcon,
  zap: ZapIcon
};
export function BenefitsSection() {
  return <section aria-labelledby="beneficios" className="border-b border-line bg-canvas" data-id="element-17" data-mp="3norkjv8lzu0g">
      <div className="mx-auto max-w-3xl px-4 py-8 sm:py-10" data-id="element-18" data-mp="38saar8g2ing0">
        <SectionHeader id="beneficios" title="¿Qué puede cambiar cuando empiezas?" description="Una habilidad técnica puede abrir nuevas posibilidades." data-id="element-19" data-mp="38qpkvw4p7soh" />
        <ul className="mt-5 grid gap-2.5 sm:grid-cols-2" data-id="element-20" data-mp="2zt6tma0goi45">
          {benefits.map(b => {
          const Icon = ICONS[b.icon];
          return <li key={b.title} className="flex gap-3 rounded-xl border border-line bg-surface p-3.5" data-id="element-21" data-mp="xzftnc3tcy0j">
                <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-success/15" data-id="element-22" data-mp="12zc2pprdbfmy">
                  <Icon size={16} aria-hidden="true" className="text-success" data-id="element-23" data-mp="2bduv119xawfx" />
                </span>
                <div data-id="element-24" data-mp="27csumh49secd">
                  <h3 className="font-display text-sm font-extrabold text-ink" data-id="element-25" data-mp="27dc2t644bod7">{b.title}</h3>
                  <p className="mt-1 text-[0.8rem] leading-snug text-muted sm:text-sm" data-id="element-26" data-mp="2l47boiema5gs">{b.desc}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}